import React, { useState, forwardRef } from 'react';
import '../../styles/sections/sidebars/SidebarNav.css';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import TelegramIcon from '@mui/icons-material/Telegram';
import { Fade } from 'react-awesome-reveal';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert, { type AlertProps } from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const isMobile = window.innerWidth < 600;

export const SidebarNav: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText('oleg@glotov.com');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackbarClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleSnackbarClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  if (isMobile) {
    return (
      <div className="navAreaNav">
        <div className="navElements">
          <div className="linkSocial">
            <div className="linkIcon email" onClick={handleClick}>
              <EmailIcon sx={{ fontSize: 35 }} />
            </div>
          </div>

          <div className="linkSocial">
            <a
              className="linkIcon linkedin"
              href="https://www.linkedin.com/in/olegglotov/"
            >
              <LinkedInIcon sx={{ fontSize: 35 }} />
            </a>
          </div>

          <div className="linkSocial">
            <a className="linkIcon github" href="https://github.com/OlegGlo">
              <GitHubIcon sx={{ fontSize: 32 }} />
            </a>
          </div>

          <div className="linkSocial">
            <a className="linkIcon telegram" href="https://t.me/oleg_glo">
              <TelegramIcon sx={{ fontSize: 35 }} />
            </a>
          </div>

          <Dialog open={open} keepMounted onClose={handleClose}>
            <Snackbar
              className="snackbar"
              open={open}
              autoHideDuration={3000}
              onClose={handleSnackbarClose}
              message="Email saved to clipboard"
              action={action}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity="info"
                sx={{ width: '100%', color: 'black', backgroundColor: 'white' }}
              >
                Email copied to clipboard!
              </Alert>
            </Snackbar>
          </Dialog>
        </div>
      </div>
    );
  }

  return (
    <div className="navAreaNav">
      <div className="navElements">
        <Fade delay={800} direction="left">
          <div className="linkSocial">
            <a
              className="linkIcon linkedin"
              href="https://www.linkedin.com/in/olegglotov/"
            >
              <LinkedInIcon sx={{ fontSize: 35 }} />
            </a>
          </div>
        </Fade>
        <Fade delay={1200} direction="left">
          <div className="linkSocial">
            <a className="linkIcon github" href="https://github.com/OlegGlo">
              <GitHubIcon sx={{ fontSize: 32 }} />
            </a>
          </div>
        </Fade>
        <Fade delay={1600} direction="left">
          <div className="linkSocial">
            <a className="linkIcon telegram" href="https://t.me/oleg_glo">
              <TelegramIcon sx={{ fontSize: 35 }} />
            </a>
          </div>
        </Fade>
      </div>
    </div>
  );
};
